export const EVENT_PATH = 'path';
export const EVENT_ENGINE_OFF = 'engineOff';
export const EVENT_ALARM = 'event';

export const EVENT_ALARM_TYPE_LIST: { [key: string]: string } = {
  [EVENT_PATH]: 'Trayectos',
  [EVENT_ENGINE_OFF]: 'Apagados',
  [EVENT_ALARM]: 'Alarmas',
};
